<template>
  <div class="menu-list">
    <!-- 套餐列表 -->
      <div class="menu-title">
        <div class="menu-right">
          <CDNButton
           :BtnText="$t('allDomain.add')"
           :hasBg="true"
           :imgPath="require('@/assets/images/products/icon_plus.png')"
           @btnclick="addpackage"
            />
        </div>

      </div>
      
      <el-table
       :data="tableData"
       style="width: 100%"
    >
        <el-table-column
          align="center"
          prop="rcondUri"
          :label="$t('allDomain.domain')"
        >
        </el-table-column>
        <el-table-column
          align="center"
          prop="httpcode"
          :label="$t('allDomain.linkMode')"
        >
        </el-table-column>
        <el-table-column
          align="center"
          prop="redirectUri"
          :label="$t('allDomain.redictLink')"
        >
        </el-table-column>
        <el-table-column
          align="center"
          :label="$t('product.handle')"
        >
        <template slot-scope="scope">
          <div>
                <img style="width: 18px;height:18px;"
                 @click="delRowClick(scope.row)"
                src="@/assets/images/domain/icon_delete.png" alt="">
              </div>
        </template>
        </el-table-column>

      </el-table>
       
      <div class="pagination-bottom">
        <Pagination
        :total="total"
        :page-size="pageSize"
        :page-count="pageCount"
        @change="handleChange"
      />
      </div>

      <el-dialog
        :title="`${$t('allDomain.rootDomain')}：${rootDomain}`"
        :visible.sync="dialogVisible2"
        width="532px">
        <CDNRadios
            v-model="cdnRadiosHttp"
            :items="items"
            :hasLine="false"
            label="http/https"
         />
         <div class="url-content">
         <loginInput
            :label="$t('allDomain.URLRule')"
            inputStyle="width: 94px;"
            realInputStyle="width: 94px;height: 40px;"
            :placeholder="$t('allDomain.subdomainTip')"
            @changeInput="e => prefix_host = e"
          />
          <div class="urlRule-text">{{rootDomain}}</div>
          <loginInput
            inputStyle="width: 94px;"
            realInputStyle="width: 94px;height: 40px;"
            :placeholder="$t('allDomain.subdomainTip2')"
            @changeInput="e => suffix_host = e"
          />
         </div>
        <div class="dialog-content">
          <loginInput
            :label="$t('allDomain.redictLink')"
            inputStyle="width: 484px;"
            realInputStyle="width: 484px;height: 40px;"
            bottomTip="https://www.yuming.com/?param=0"
            tipStyle="margin-left: -16px;"
            @changeInput="e => linkUrl = e"
          />
    <!--  -->
          <div class="dialog-btn">
            <div @click="commitclick">{{$t('allDomain.add')}}</div>
          </div>
        </div>
      </el-dialog>
      <!--  -->
    </div>
</template>

<script>
/*eslint-disable*/ 
import { addRetic, ReticList, updateRetic, delRetic } from '@/service/requestRes';
export default {
  props: {
    rootDomain: String,
  },
  data() {
    return {
      total: 0,
      pageSize: 10,
      pageCount: 1,
      dialogVisible2: false,
      cdnRadios: 1,
      cdnRadiosHttp: 'http',
      suffix_host: '',
      prefix_host: '',
      linkUrl: '',
      items: [
        {
          label: 'http',
          value: 'http',
        },
        {
          label: 'https',
          value: 'https',
        },
      ],
      tableData: [],
    };
  },
  computed: {
    headerLables() {
      return [
        { label: this.$t('allDomain.domain'), value: 'rcondUri' },
        { label: this.$t('allDomain.linkMode'), value: 'httpcode' },
        { label: this.$t('allDomain.redictLink'), value: 'redirectUri' },
        { label: this.$t('product.handle'), value: 'handle' },
      ];
    },
  },
  mounted() {
    this.getCurrentList({page: 1});
  },
  methods: {
    addCurrentItem({
      sub_host,
  scheme,
  http_code,
  prefix_host,
  suffix_host,
  redirectUri,
    }) {
      addRetic({
        sub_host,
  scheme,
  http_code,
  prefix_host,
  suffix_host,
  redirectUri,
      }).then(res => {
      const { code, msg } = res || {};
        if (code === 1) {
            this.getCurrentList({page: 1});
            this.dialogVisible2 = false;
        } else {
          this.$message({
            message: msg,
            type: "error",
          });
        }
      });
    },
    getCurrentList({ page }) {
      ReticList({
        page,
        limit: this.pageSize,
        sub_host: this.rootDomain,
      }).then(res => {
         const { data, code, msg } = res || {};
        if (code === 1) {
          const { total } = data || {};
          this.total = total;
          this.tableData =data.data;
        } else {
          this.$message({
            message: msg,
            type: "error",
          });
        }
      });
    },
    updateItem({
      rcondUri, http_code, redirectUri
    }) {
      updateRetic({
        rcondUri, http_code, redirectUri
      }).then(res => {
      const { data, code, msg } = res || {};
        if (code === 1) {

        } else {
          this.$message({
            message: msg,
            type: "error",
          });
        }
      });
    },
    delItem({ id }) {
      delRetic({id}).then(res => {
  const { data, code, msg } = res || {};
        if (code === 1) {
          this.getCurrentList({page: 1});
        } else {
          this.$message({
            message: msg,
            type: "error",
          });
        }
      });
    },
    refresh() {
      console.log('refresh');
    },
    addpackage() {
      this.dialogVisible2 = true;
    },
    editRowClick(item) {
      console.log(item);
    },
    delRowClick(item) {
      this.delItem({ id: item.id });
    },
    handleChange(e) {
      this.getCurrentList({page: e});
    },
    commitclick() {
  // http_code,
  // prefix_host,
  // suffix_host,
      if (!this.linkUrl) {
          this.$message({
            message: '请输入跳转链接',
            type: "error",
          });
        return;
      }
      this.addCurrentItem({
        sub_host: this.rootDomain,
        scheme: this.cdnRadiosHttp,
        redirectUri: this.linkUrl,
        http_code: 301,
        prefix_host: this.prefix_host,
        suffix_host: this.suffix_host,
      });
    },
  },
};
</script>

<style lang='scss' scoped>
  .menu-list {
    width: 1276px;
    background-color: white;
    padding: 24px;
    border-radius: 4px;
    .menu-title {
      display: flex;
      justify-content: flex-end;
      margin-right: 30px;
      span {
        font-family: PingFangSC-Semibold;
        font-size: 14px;
        color: #5A607F;
      }
      .menu-right {
        height: 60px;
        display: flex;
        align-items: center;
      }
    }
    .filter-container {
      display: flex;
      align-items: center;
    }
     .input-container {
      display: flex;
      align-items: center;
      margin-bottom: 24px;
    }
    .search-btn-content {
      display: flex;
      margin-bottom: 49px;
    }

  .dialog-btn {
     width: 100%;
     display: flex;
     align-items: center;
     justify-content: center;
     margin-top: 24px;
   :first-child {
     background: #D9E4FF;
     border-radius: 4px;
     width: 98px;
     height: 40px;
     text-align: center;
     line-height: 40px;
     font-family: PingFangSC-Semibold;
     font-size: 14px;
     color: #1E5EFF;
     letter-spacing: 0;
   }
 }
 .url-content {
   display: flex;
   align-items: flex-end;
   margin-bottom: 24px;
 }
 .urlRule-text {
   width: 100px;
   height: 40px;
   line-height: 40px;
   text-align: center;
   background-color: rgba(0, 0, 0, 0.2);
   border-radius: 3px;
   margin-bottom: 5px;
 }
  }
</style>
